import { render, staticRenderFns } from "./add-service-place.vue?vue&type=template&id=2ab17c60&"
import script from "./add-service-place.vue?vue&type=script&lang=js&"
export * from "./add-service-place.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports